import React from "react";

import dayjs from "dayjs";

import { colors } from "components";

import { BaseCard } from "components/BaseCard";
import { CircularButton } from "components/CircularButton";
import { SquareCard } from "components/SquareCard";

import { IScheduleCard } from "./interfaces";
import {
  ButtonContainer,
  ScheduleCardTopContainer,
  Container,
  LeftContainer,
  RightContainer,
} from "./styles";

export const ScheduleCard: React.FC<IScheduleCard> = ({
  id,
  selected = false,
  day,
  time,
  copyTooltip,
  disabledCopy = false,
  disabledDelete = false,
  disabledEdit = false,
  disabledRecord = false,
  disabled = false,
  hideCopyButton = false,
  squareHeight,
  squareWidth,
  onClickItem,
  onClickDelete,
  onClickCopy,
  onClickEdit,
  onClickRecord,
}) => {
  const fullDayFormat = dayjs(day).format("DD/MM/YYYY");
  const dayFormat: string =
    fullDayFormat === dayjs(new Date()).format("DD/MM/YYYY")
      ? "Hoje"
      : dayjs(day).format("DD/MM/YYYY");

  const hourFormat: string = dayjs(time).format("HH:mm");
  return (
    <ScheduleCardTopContainer data-testid={id}>
      <BaseCard
        selected={selected}
        fixedBorder={true}
        onClick={onClickItem}
        disabled={disabled}
      >
        <Container>
          <LeftContainer>
            <SquareCard
              title={dayFormat}
              subTitle={hourFormat}
              width={squareWidth}
              height={squareHeight}
            />
          </LeftContainer>
          <RightContainer id="buttonsRight">
            {!hideCopyButton && (
              <ButtonContainer id="copy_button">
                <CircularButton
                  id="copy_button_circular"
                  icon="copy"
                  copyTooltip={copyTooltip}
                  onClick={onClickCopy}
                  colorIcon={colors.neutral_white}
                  border={`2px solid ${colors.primary_default}`}
                  backgroundColor={colors.primary_default}
                  disabled={disabledCopy}
                />
              </ButtonContainer>
            )}
            <ButtonContainer id="delete_button">
              <CircularButton
                id="delete_button_circular"
                icon="delete"
                onClick={onClickDelete}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledDelete}
              />
            </ButtonContainer>
            <ButtonContainer id="edit_button">
              <CircularButton
                id="edit_button_circular"
                icon="edit"
                onClick={onClickEdit}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledEdit}
              />
            </ButtonContainer>
            <ButtonContainer id="record_button">
              <CircularButton
                id="record_button_circular"
                icon="record"
                onClick={onClickRecord}
                colorIcon={colors.neutral_white}
                border={`2px solid ${colors.primary_default}`}
                backgroundColor={colors.primary_default}
                disabled={disabledRecord}
                highlight
              />
            </ButtonContainer>
          </RightContainer>
        </Container>
      </BaseCard>
    </ScheduleCardTopContainer>
  );
};
